import React, { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { Button } from "react-bootstrap";
import styles from "../Events/Events.module.css";

const EventIntroGallery = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    import("./imgData.js")
      .then((data) => setImages(data.default || data))
      .catch((error) => console.error("Failed to load gallery data:", error));
  }, []);

  return (
    <div style={{ maxWidth: "900px", margin: "0 auto" }}>
      <ImageGallery
        items={images}
        autoPlay={true}
        showPlayButton={false}
        showNav={true}
        showThumbnails={true}
        slideInterval={3000}
        slideDuration={800} // Short transition time (fade-like)
        showFullscreenButton={false}
      />
      <div>
        <Button href="/event-showcases" className={styles.galleryButton}>
          VIEW EVENTS PAGE
        </Button>
      </div>
    </div>
  );
};

export default EventIntroGallery;
